import { render, staticRenderFns } from "./Podium.vue?vue&type=template&id=f223f220&scoped=true&"
import script from "./Podium.vue?vue&type=script&lang=js&"
export * from "./Podium.vue?vue&type=script&lang=js&"
import style0 from "./Podium.vue?vue&type=style&index=0&id=f223f220&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f223f220",
  null
  
)

export default component.exports